import { useEntity } from 'app/agriculture/queries/entities/useEntity';
import { useParamsId } from 'app/agriculture/charts/useParamsId';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';

export function GateContent() {
    const id = useParamsId();
    const { gateType } = useEntity({ entityId: id, entityType: 'Gate' });

    return <StatDisplay name="Type" value={gateType} />;
}
